import { CloseBtn } from '@webapp/common/components/close-btn';
import css from '@webapp/common/components/modal/modal.css';

import { Actions } from './actions';
import type { ModalContentProps } from './types';

export const ModalContent: FC<ModalContentProps> = ({
    title,
    children,
    closeBtn,
    titleAlign,
    acceptText,
    cancelText,
    onAccept,
    onClose,
    onCancel,
    onRemove,
    onPurge,
    disableAcceptBtn,
}) => {
    return (
        <>
            {title && (
                <div className={css.title} style={{ textAlign: titleAlign }}>
                    {title}
                </div>
            )}
            {closeBtn && <CloseBtn className={css.close} onClick={onClose} />}
            {children}
            {(onRemove || onCancel || onAccept) && (
                <Actions
                    acceptText={acceptText}
                    cancelText={cancelText}
                    onAccept={onAccept}
                    onCancel={onCancel}
                    onPurge={onPurge}
                    onRemove={onRemove}
                    disableAcceptBtn={disableAcceptBtn}
                />
            )}
        </>
    );
};
